// src/components/DashboardRouter.jsx

console.log("[DashboardRouter] file loaded");

import {
  Box,
  Button,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
} from "@chakra-ui/react";

import {
  Outlet,
  useLocation,
} from "react-router-dom";

import {
  useEffect,
} from "react";

import DashboardSidebar from "./DashboardSidebar";

const BRAND_RED = "#E63946";
const BRAND_RED_LIGHT = "#FFF5F5";

export default function DashboardRouter() {
  console.log(
    "[DashboardRouter] component rendered"
  );

  const location = useLocation();

  const {
    isOpen,
    onOpen,
    onClose,
  } = useDisclosure();

  /*
   * CampaignDashboard already includes its own
   * responsive menu button and desktop sidebar.
   *
   * Every other cockpit page receives the global
   * mobile menu from this layout.
   */
  const isMainDashboard =
    location.pathname === "/dashboard" ||
    location.pathname === "/dashboard/";

  /*
   * Automatically close the mobile drawer
   * whenever navigation changes.
   */
  useEffect(() => {
    onClose();
  }, [
    location.pathname,
    onClose,
  ]);

  return (
    <>
      {!isMainDashboard && (
        <>
          <Box
            display={{
              base: "block",
              md: "none",
            }}
            width="100%"
            px={4}
            pt={4}
            pb={0}
            bg="white"
          >
            <Button
              onClick={onOpen}
              width="100%"
              justifyContent="flex-start"
              bg="white"
              color={BRAND_RED}
              borderWidth="1px"
              borderColor={BRAND_RED}
              boxShadow="sm"
              _hover={{
                bg: BRAND_RED_LIGHT,
              }}
              _active={{
                bg: BRAND_RED_LIGHT,
              }}
            >
              ☰ Menu
            </Button>
          </Box>

          <Drawer
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            size="xs"
          >
            <DrawerOverlay />

            <DrawerContent
              borderRightWidth="4px"
              borderRightColor={BRAND_RED}
            >
              <DrawerCloseButton
                color={BRAND_RED}
                zIndex={2}
              />

              <Box
                pt={12}
                height="100%"
                overflowY="auto"
              >
                <DashboardSidebar />
              </Box>
            </DrawerContent>
          </Drawer>
        </>
      )}

      {console.log(
        "[DashboardRouter] outlet rendered"
      )}

      <Outlet />
    </>
  );
}

console.log("[DashboardRouter] ready");